import { Component, EventEmitter, Inject, Output } from '@angular/core';
import {
  ISummaryData,
  ProductInformation,
  ServiceConfiguration,
} from '../../../../../../../core/models/summary-data';
import { FuelTypeOption } from '../../../../../../../core/interfaces/funnel.interface';
import { Router } from '@angular/router';
import { ProductSelectionService } from '../../../../../../../core/services/product-selection.service';
import { SummaryService } from '../../../../../../../core/services/summary.service';
import { CatalogService } from '../../../../../../../core/services/catalog.service';
import { FunnelService } from '../../../funnel.service';
import { MappedTopping } from '../../../../../../../core/models/topping.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { LoaderService } from '../../../../../../../core/services/loader.service';
import { ConfirmDialogComponent } from '../../../../../../../shared/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-modal-extra-refill',
  standalone: false,
  templateUrl: './modal-extra-refill.component.html',
  styleUrl: './modal-extra-refill.component.scss',
})
export class ModalExtraRefillComponent {
  @Output() catalogDataCompleted = new EventEmitter<ProductInformation>();

  selectedItem: any;
  selectedItemCards: any;
  fuelTypeOptions: FuelTypeOption[] = [];
  selectedFuelType = 0;
  showResume = false;
  summaryData: ISummaryData = {} as ISummaryData;
  fuelTypeFromSummaryData: number | undefined = 0;
  totalOrderAmount = 0;
  selectedProductId: string | undefined = undefined;
  selectedProduct: any = undefined;
  serviceConfiguration: any = undefined;

  constructor(
    private loaderService: LoaderService,
    private dialog: MatDialog,
    private router: Router,
    private productService: ProductSelectionService,
    private summaryService: SummaryService,
    private catalogDataService: CatalogService,
    private funnelService: FunnelService,
    @Inject(MAT_DIALOG_DATA)
    public data: { orderHash: string; mappedTopping: MappedTopping },
    private dialogRef: MatDialogRef<ModalExtraRefillComponent>
  ) {
    this.selectedItem =
      this.router.getCurrentNavigation()?.extras.state?.['selectedItem'];
    this.selectedItemCards = this.selectedItem?.product?.relatedCards;
    const stored = this.summaryService.getSummary();
    if (stored) {
      this.summaryData = stored;
    } else {
      const local = localStorage.getItem('summaryData');
      if (local) {
        this.summaryData = JSON.parse(local);
        this.summaryService.setSummary(this.summaryData);
      } else {
        this.summaryData = {
          productInformation: {},
        };
      }
    }
  }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    this.selectedProductId = this.data.mappedTopping.products[0].Id;
    this.selectedProduct = this.data.mappedTopping.products[0];
    const selected = this.productService.getProduct();
    this.selectedItem = selected;
    this.fuelTypeFromSummaryData = this.summaryData.vehicleData?.fuelType;
    console.log('fuelTypeFromSummaryData', this.fuelTypeFromSummaryData);
    if (
      this.fuelTypeFromSummaryData == 1 ||
      this.fuelTypeFromSummaryData == 5
    ) {
      this.selectFuel('gasolina95');
    }
    if (
      this.fuelTypeFromSummaryData == 3 ||
      this.fuelTypeFromSummaryData == 5
    ) {
      this.selectFuel('diesel');
    }
    this.selectAmount(10);
    console.log('selectedFuel', this.selectedFuel);
    console.log('selectedAmount', this.selectedAmount);
  }

  selectedFuel: string | undefined;
  selectedFuelCode: number | undefined;
  selectedAmount: number | undefined;

  selectFuel(fuel: string): void {
    switch (fuel) {
      case 'gasolina95':
        this.selectedFuelCode = 1;
        this.selectedFuel = 'gasolina95';
        break;
      case 'gasolina98':
        this.selectedFuelCode = 2;
        this.selectedFuel = 'gasolina98';
        break;
      case 'diesel':
        this.selectedFuelCode = 4;
        this.selectedFuel = 'diesel';
        break;
      case 'dieselPremium':
        this.selectedFuelCode = 8;
        this.selectedFuel = 'dieselPremium';
        break;
      default:
        this.selectedFuel = undefined;
        break;
    }
  }

  selectAmount(amount: number): void {
    this.selectedAmount = amount;
  }

  isFormValid(): boolean {
    return this.selectedFuel !== null && this.selectedAmount !== null;
  }

  showForm(): void {
    this.showResume = true;
  }

  addTopping(): void {
    const serviceConfiguration: ServiceConfiguration = {
      fuelType: this.selectedFuelCode ?? 0,
      monetaryAmount: this.selectedAmount ?? 0,
    };
    this.loaderService.show();
    this.funnelService
      .addTopping(
        this.selectedProductId!,
        this.data.orderHash,
        serviceConfiguration,
        'refill'
      )
      ?.pipe(finalize(() => this.loaderService.hide()))
      .subscribe((response) => {
        this.summaryData = {
          ...this.summaryData,
          bookingResponse: response,
        };
        this.summaryService.setSummary(this.summaryData);
        this.dialogRef.close({
          selectedAmount: this.selectedAmount,
          selectedFuel: this.selectedFuel,
          selectedProduct: this.selectedProduct,
          response: response,
        });
      });
  }

  onClose(): void {
    const confirmationDialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'sure_you_wanna_leave',
        message: 'disclousure_message_confirmation_dialog',
        confirmText: 'confirm',
        cancelText: 'cancel',
      },
    });

    confirmationDialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.closeMainDialog();
      }
    });
  }

  private closeMainDialog(): void {
    this.dialogRef.close({ incompletedTopping: true });
  }
}
